(function () {
  'use strict';

  if (window.SpotkickCoachPageV2 && typeof window.SpotkickCoachPageV2.init === 'function') {
    window.SpotkickCoachPageV2.init(document);
    return;
  }

  function motionPreference() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function initializeSlider(slider) {
    if (!slider || slider.dataset.sliderReady === 'true') return;

    var track = slider.querySelector('[data-slider-track]');
    var previous = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');

    if (!track || !previous || !next) return;

    slider.dataset.sliderReady = 'true';

    function distance() {
      var card = track.querySelector('[data-slider-card]');
      if (!card) return track.clientWidth * 0.85;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum;

      if (maximum <= 2) {
        previous.hidden = true;
        next.hidden = true;
      } else {
        previous.hidden = false;
        next.hidden = false;
      }
    }

    previous.addEventListener('click', function () {
      track.scrollBy({ left: -distance(), behavior: motionPreference() });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: distance(), behavior: motionPreference() });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateControls);
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      track.scrollBy({
        left: event.key === 'ArrowLeft' ? -distance() : distance(),
        behavior: motionPreference()
      });
    });

    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initializeProductForm(form) {
    if (!form || form.dataset.productReady === 'true') return;
    form.dataset.productReady = 'true';

    var button = form.querySelector('.add-to-cart');
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var status = form.querySelector('[data-product-status]');
    var originalText = buttonText ? buttonText.textContent.trim() : '';

    if (window.theme && typeof window.theme.AjaxProduct === 'function') {
      new window.theme.AjaxProduct(form);
    }

    form.addEventListener('ajaxProduct:added', function () {
      if (status) {
        status.classList.remove('is-error');
        status.textContent = 'Added to cart.';
      }

      if (buttonText) buttonText.textContent = 'Added';

      window.setTimeout(function () {
        if (buttonText) buttonText.textContent = originalText;
        if (status) status.textContent = '';
      }, 1800);

      if (window.dataLayer && button) {
        window.dataLayer.push({
          event: 'coach_pack_add_to_cart',
          coach_pack_name: button.dataset.packName || ''
        });
      }
    });

    form.addEventListener('ajaxProduct:error', function (event) {
      if (!status) return;
      status.classList.add('is-error');
      status.textContent = event.detail && event.detail.errorMessage
        ? String(event.detail.errorMessage)
        : 'This pack could not be added. Please try again.';
    });
  }

  function initializeAnchorLinks(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.anchorReady === 'true') return;
      link.dataset.anchorReady = 'true';

      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;

        var target = document.querySelector(targetId);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: motionPreference(), block: 'start' });
        window.history.replaceState(null, '', targetId);
      });
    });
  }

  function initializeMobileBar(root) {
    var bar = root.querySelector('[data-mobile-bar]');
    var hero = document.querySelector('.skc-hero');
    var finalSection = document.querySelector('.skc-final');
    if (!bar || !hero) return;

    function updateBar() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }

      var heroBottom = hero.getBoundingClientRect().bottom;
      var finalTop = finalSection ? finalSection.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      var visible = heroBottom < 40 && finalTop > window.innerHeight * 0.68;

      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar, { passive: true });
    updateBar();
  }

  function initializeAnalytics(root) {
    root.querySelectorAll('a[href*="CoachPacks"], a[href*="CoachBulk"]').forEach(function (link) {
      if (link.dataset.trackingReady === 'true') return;
      link.dataset.trackingReady = 'true';

      link.addEventListener('click', function () {
        if (!window.dataLayer) return;
        window.dataLayer.push({
          event: link.getAttribute('href').indexOf('CoachBulk') > -1
            ? 'coach_bulk_cta_click'
            : 'coach_packs_cta_click',
          coach_cta_label: link.textContent.trim()
        });
      });
    });
  }

  function initializePage(root) {
    if (!root || root.dataset.pageReady === 'true') return;
    root.dataset.pageReady = 'true';

    root.querySelectorAll('[data-coach-slider]').forEach(initializeSlider);
    root.querySelectorAll('[data-coach-product-form]').forEach(initializeProductForm);
    initializeAnchorLinks(root);
    initializeMobileBar(root);
    initializeAnalytics(root);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-coach-page]').forEach(initializePage);
  }

  window.SpotkickCoachPageV2 = {
    init: initializeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
